/* Lumiso perde configurator — B modeli (24 Eyl 2026)
 *
 * Perde variant'i = Width x Header x Lining (1.188). Liquid sayfalanmadan en fazla 250
 * variant dondurdugu icin variant listesi istemciye gonderilmez; secim degisince variant
 * Section Rendering API ile sunucuda cozulur:
 *   GET {product_url}?section_id={id}&option_values=<id>,<id>,<id>
 * Boy variant DEGIL: "Extra drop" urununun (Width x Lining) inc fiyati x (Boy - billFloor).
 *   panel fiyati = perde variant fiyati + extra drop inc fiyati x max(Boy - billFloor, 0)
 * (Excel kurali: billFloor=40 inc altindaki boylar 40 inc fiyatindan satilir.)
 * Iki fiyat da admin'deki variant fiyatidir; burada formul YOK. Sepete iki satir gider,
 * eslesme `_lc_ref` ile (sepet tarafi: assets/lumiso-cart-sync.js).
 * Matching tieback (26 Eyl 2026): tieback urunu panel adedi kadar ucuncu satir olarak gider
 *   (_lc_addon = "tieback"); panel fiyatina tieback variant fiyati eklenir.
 */
(function () {
  "use strict";

  function boot(root) {
    if (root.dataset.lcReady === "1") return;
    root.dataset.lcReady = "1";

    var productUrl = root.dataset.productUrl;
    var sectionId = root.dataset.sectionId;
    var fabricWidth = parseFloat(root.dataset.fabricWidth) || 53;
    var fullness = parseFullness(root.dataset.fullness);

    var moneyFormat = root.dataset.moneyFormat || "${{amount}}";
    var minDrop = parseInt(root.dataset.minDrop, 10) || 16;
    var maxDrop = parseInt(root.dataset.maxDrop, 10) || 150;
    var billFloor = parseInt(root.dataset.billFloor, 10);
    if (!isFinite(billFloor) || billFloor < minDrop) billFloor = minDrop;
    function extraInches(l) { return Math.max(l - billFloor, 0); }
    var productTitle = root.dataset.productTitle || "";
    var drop = readDrop();
    var tbVariant = parseInt(root.dataset.tiebackVariant, 10) || null;
    var tbPrice = parseInt(root.dataset.tiebackPrice, 10) || 0;
    function tbOn() { return /^matching/i.test(state.tieback || ""); }

    // Ipli ekstrafor (gathering tape) header'lari: panel DUZ ve tam siparis
    // genisliginde gider, pileyi musteri ipi cekerek kendi ayarlar.
    // Bu listede OLMAYAN ama fullness orani OLAN header (Back Tape) fabrikada pilelenir.
    var tapeHeaders = parseNames(root.dataset.tapeHeaders);
    var tapeSeconds = parseFloat(root.dataset.tapeSeconds) || 7;

    // qty: panel adedi. qtyTouched -> musteri sayaca elle dokundu mu?
    // Dokunduysa rod yardimcisi bir daha adedi degistirmez.
    var state = { tieback: null, subs: {}, photo: 0, pending: null, seq: 0,
                  qty: 1, qtyTouched: false,
                  tapeSeen: null, tapeTouched: false, tapeTimer: null, rod: "",
                  // musterinin girdigi olcu: gecerli degilse null. wRaw/lRaw kutudaki metin
                  // (canli bolge tazelenince kutular yeniden yazilir).
                  w: null, l: null, wRaw: "", lRaw: "", busy: false };

    function readDrop() {
      var el = root.querySelector("[data-lc-drop-json]");
      try { return el ? JSON.parse(el.textContent) : { v: {} }; } catch (e) { return { v: {} }; }
    }

    /* ---------- yardimcilar ---------- */
    function $(sel, ctx) { return (ctx || root).querySelector(sel); }
    function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

    function parseFullness(raw) {
      var map = {};
      (raw || "").split("\n").forEach(function (line) {
        var i = line.indexOf("=");
        if (i < 0) return;
        var name = line.slice(0, i).trim();
        var n = parseFloat(line.slice(i + 1));
        if (name && isFinite(n) && n > 0) map[name.toLowerCase()] = n;
      });
      return map;
    }

    function fullnessOf(name) { return fullness[(name || "").trim().toLowerCase()] || null; }

    function parseNames(raw) {
      var set = {};
      (raw || "").split("\n").forEach(function (line) {
        var v = line.trim().toLowerCase();
        if (v) set[v] = 1;
      });
      return set;
    }
    // true  -> ipli ekstrafor: duz gider, musteri ipi cekerek buzer
    function isTape(name) { return !!tapeHeaders[(name || "").trim().toLowerCase()]; }

    // Bitmis genislik MUSTERININ girdigi genislige gore; girilmediyse null.
    function selectedWidth() { return state.w; }
    function finishedWidth(name, w) {
      w = w || selectedWidth();
      var f = fullnessOf(name);
      return f ? Math.round(w / f * 10) / 10 : w;
    }

    // Genislik degerleri option value adlarindan okunur ('53"').
    function sizeNodes() { return $$("[data-lc-len-map] i"); }
    function widths() {
      return sizeNodes().map(function (n) { return parseInt(n.dataset.lcW, 10); })
        .filter(isFinite).sort(function (a, b) { return a - b; });
    }
    function selectedLiningName() {
      var el = $("[data-lc-step='lining'] [data-lc-value][aria-pressed='true']");
      return el ? el.dataset.lcName : null;
    }
    // Secili genislik+astar icin extra drop [variant id, inc basi cent] ya da null
    function dropEntry() {
      if (state.w === null) return null;
      return (drop.v || {})[state.w + "|" + selectedLiningName()] || null;
    }
    function ready() { return state.w !== null && state.l !== null && !!dropEntry(); }

    /* ---------- galeri ---------- */
    function paintGallery() {
      $$("[data-lc-slide]").forEach(function (s) {
        s.hidden = parseInt(s.dataset.lcSlide, 10) !== state.photo;
      });
      $$("[data-lc-thumb]").forEach(function (t) {
        t.setAttribute("aria-pressed", parseInt(t.dataset.lcThumb, 10) === state.photo ? "true" : "false");
      });
    }

    /* ---------- secili option value id'leri ---------- */
    function selectedIds() {
      var byPos = {};
      $$("[data-lc-value][aria-pressed='true']").forEach(function (el) {
        byPos[el.dataset.lcPos] = el.dataset.lcValue;
      });
      var lenSel = $("[data-lc-len-map] [data-lc-selected]");
      if (lenSel) byPos[lenSel.dataset.lcPos] = lenSel.dataset.lcValue;
      return Object.keys(byPos).sort(function (a, b) { return a - b; })
        .map(function (k) { return byPos[k]; });
    }

    function selectedHeaderName() {
      var el = $("[data-lc-step='header'] [data-lc-value][aria-pressed='true']");
      return el ? el.dataset.lcName : null;
    }

    /* ---------- sunucudan variant coz ---------- */
    function refetch() {
      var ids = selectedIds();
      if (!ids.length) return;
      var seq = ++state.seq;
      var url = productUrl + "?section_id=" + encodeURIComponent(sectionId) +
                "&option_values=" + ids.join(",");

      setBusy(true);
      if (state.pending) state.pending.abort();
      var ctl = new AbortController();
      state.pending = ctl;

      fetch(url, { signal: ctl.signal })
        .then(function (r) {
          if (!r.ok) throw new Error("HTTP " + r.status);
          return r.text();
        })
        .then(function (html) {
          if (seq !== state.seq) return;              // eski istek — yoksay
          var doc = new DOMParser().parseFromString(html, "text/html");
          var fresh = doc.querySelector("[data-lc-live]");
          var live = $("[data-lc-live]");
          if (!fresh || !live) throw new Error("canli bolge bulunamadi");

          var openStep = openStepId();
          live.innerHTML = fresh.innerHTML;
          restore(openStep);
          setBusy(false);
        })
        .catch(function (e) {
          if (e.name === "AbortError") return;
          setBusy(false);
          note("Could not update the price. Please try again.");
          if (window.console) console.error("[lumiso-configurator]", e);
        });
    }

    function setBusy(on) {
      state.busy = !!on;
      root.classList.toggle("lc--busy", !!on);
      paintCta();
    }

    /* ---------- sepet butonu: tek karar noktasi ---------- */
    function missingSub() {
      return $$("[data-lc-sub-group]").map(function (b) { return b.dataset.lcSubGroup; })
        .filter(function (g) { return !state.subs[g]; })[0] || null;
    }
    function paintCta() {
      var cta = $("[data-lc-cta]");
      if (!cta) return;
      var vid = $("[data-lc-variant-id]");
      var ok = ready() && !state.busy && vid && vid.value && !missingSub() &&
               !/unavailable/i.test(cta.textContent);
      cta.disabled = !ok;
    }

    function note(msg) {
      var n = $("[data-lc-note]");
      if (n) n.textContent = msg || "";
    }

    function openStepId() {
      var open = $(".lc-item.is-open");
      return open ? open.dataset.lcStep : null;
    }

    /* ---------- tazelemeden sonra durumu geri koy ---------- */
    function restore(openStep) {
      if (openStep) {
        $$(".lc-item").forEach(function (it) {
          it.classList.toggle("is-open", it.dataset.lcStep === openStep);
        });
      }
      syncSizeInputs();
      syncRodInput();
      applyTieback();
      applySub();
      paintFullness();
      paintTape();
      paintPanelHelper();
      paintQty();
      paintDone();
      note("");
      paintCta();
    }

    /* ---------- pileli header notu ---------- */
    function paintFullness() {
      var el = $("[data-lc-fullness]");
      if (!el) return;
      var name = selectedHeaderName();
      if (!name) { el.textContent = ""; return; }
      var w = selectedWidth();
      var f = fullnessOf(name);
      if (w === null) {
        el.innerHTML = "<b>" + esc(name) + "</b> — enter your width in step 2 to see how wide it " +
          (f ? "finishes." : "hangs.");
        return;
      }
      if (f && isTape(name)) {
        el.innerHTML = "<b>" + esc(name) + "</b> ships flat at its full " + w +
          " inches, with a corded tape sewn across the back. Draw the cords and it gathers to about <b>" +
          finishedWidth(name, w) + " inches</b> at the usual " + f +
          "× spacing — work out your panel count from that number, and set the pleats fuller or looser as you like.";
      } else if (f) {
        el.innerHTML = "<b>" + esc(name) + "</b> arrives pleated. Its " + w +
          " inches of flat cloth finish at about <b>" + finishedWidth(name, w) +
          " inches</b> wide, so work out your panel count from that number rather than multiplying for fullness.";
      } else {
        el.innerHTML = "<b>" + esc(name) + "</b> hangs flat at its full " + w +
          " inches. You gather it on the rod yourself — 1.5× to 2× the rod width is the usual range.";
      }
    }

    function esc(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
    }

    /* ---------- panel sayisi yardimcisi ---------- */
    function paintPanelHelper() {
      var out = $("[data-lc-rod-out]"), rodEl = $("[data-lc-rod]");
      if (!out || !rodEl) return;
      var rod = parseFloat(rodEl.value);
      var name = selectedHeaderName();
      if (!isFinite(rod) || rod <= 0) {
        out.textContent = "Enter your rod width and we will work out the count.";
        return;
      }
      if (!name) {
        out.textContent = "Pick a header first — pleated and flat headers cover different widths.";
        return;
      }
      var w = selectedWidth(), f = fullnessOf(name), n, txt;
      if (w === null) { out.textContent = "Enter your panel width in step 2 first."; return; }
      if (f) {
        var fw = finishedWidth(name, w);
        n = Math.max(1, Math.ceil(rod / fw));
        txt = "<b>" + n + " panel" + (n > 1 ? "s" : "") + "</b> — each " + w +
              "&quot; panel closes to about " + fw + "&quot; " +
              (isTape(name) ? "once you draw the cords" : "once pleated") + ", so " + n + " × " + fw +
              "&quot; covers your " + rod + "&quot; rod.";
      } else {
        n = Math.max(1, Math.ceil(rod * 2 / w));
        var actual = Math.round(n * w / rod * 100) / 100;
        txt = "<b>" + n + " panel" + (n > 1 ? "s" : "") + "</b> at 2× fullness — " + n + " × " + w +
              "&quot; = " + (n * w) + "&quot; of cloth across a " + rod + "&quot; rod, which is " +
              actual + "× fullness.";
      }
      // Musteri sayaca dokunmadiysa oneriyi uygula; dokunduysa onun sayisi kalir.
      if (!state.qtyTouched && n !== state.qty) {
        state.qty = n;
        paintQty();
        txt += " We set the count below to " + n + " — change it if you like.";
      }
      out.innerHTML = txt;
    }

    /* ---------- ipli ekstrafor bilgi kutusu ----------
       Header ipli bir degere DEGISTIGINDE acilir, tapeSeconds sonra kapanir.
       Kutuya elle dokunulduysa (tapeTouched) bir daha otomatik kapanmaz/acilmaz. */
    function tapeBox() { return $("[data-lc-tape]"); }

    function openTape(on) {
      var box = tapeBox();
      if (!box) return;
      var body = $("[data-lc-tape-body]", box);
      var bar = $("[data-lc-tape-toggle]", box);
      if (body) body.hidden = !on;
      if (bar) bar.setAttribute("aria-expanded", on ? "true" : "false");
      box.classList.toggle("is-open", !!on);
    }

    function paintTape() {
      var box = tapeBox();
      if (!box) return;
      var name = selectedHeaderName();
      var on = isTape(name);

      box.hidden = !on;                                  // ipli degilse kutu hic gorunmez
      if (!on) {
        state.tapeSeen = null;
        clearTimeout(state.tapeTimer);
        openTape(false);
        return;
      }

      // ayni header'da kalindiysa (beden/astar degisimi) kutuyu yeniden acma
      if (state.tapeSeen === name) return;
      state.tapeSeen = name;
      if (state.tapeTouched) { openTape(false); return; }

      openTape(true);
      clearTimeout(state.tapeTimer);
      state.tapeTimer = setTimeout(function () {
        if (!state.tapeTouched) openTape(false);
      }, tapeSeconds * 1000);
    }

    /* ---------- panel adedi + toplam fiyat ----------
       Birim fiyat sunucudan gelir (data-lc-unit, cent). Toplam = birim × adet.
       Adet 1 iken sunucunun kendi money string'i gosterilir; carpim ancak
       adet >1 iken JS'te formatlanir. Ust sinir yok. */
    function formatMoney(cents, fmt) {
      fmt = fmt || "${{amount}}";
      function group(sep, dec, places) {
        var n = (cents / 100).toFixed(places).split(".");
        var head = n[0].replace(/(\d)(?=(\d\d\d)+$)/g, "$1" + sep);
        return n[1] ? head + dec + n[1] : head;
      }
      var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
      var val;
      switch (m ? m[1] : "amount") {
        case "amount_no_decimals":                       val = group(",", ".", 0); break;
        case "amount_with_comma_separator":              val = group(".", ",", 2); break;
        case "amount_no_decimals_with_comma_separator":  val = group(".", ",", 0); break;
        case "amount_with_apostrophe_separator":         val = group("'", ".", 2); break;
        case "amount_with_space_separator":              val = group(" ", ",", 2); break;
        case "amount_no_decimals_with_space_separator":  val = group(" ", "",  0); break;
        default:                                         val = group(",", ".", 2);
      }
      return fmt.replace(/\{\{\s*\w+\s*\}\}/, val);
    }

    function paintQty() {
      var q = Math.floor(state.qty);
      if (!isFinite(q) || q < 1) q = 1;
      state.qty = q;

      var box = $("[data-lc-qty]");
      if (box && document.activeElement !== box) box.value = q;

      var dec = $("[data-lc-qty-step='-1']");
      if (dec) dec.disabled = q <= 1;

      var word = $("[data-lc-qty-out]");
      if (word) word.textContent = q === 1 ? "panel" : "panels";

      var hidden = $("[data-lc-qty-input]");
      if (hidden) hidden.value = q;

      // 40 inc alti notu — canli bolge tazelenince silinmesin diye burada cizilir
      var snap = $("[data-lc-snap]");
      if (snap) snap.textContent = (state.l !== null && state.l < billFloor)
        ? "Drops under " + billFloor + " inches are priced as " + billFloor + " inches \u2014 the shortest length we cut fabric for."
        : "";

      var price = $("[data-lc-price]");
      // [data-lc-sub] DEGIL: o oznitelik swatch/astar kartlarinda da var, ilkini ezerdi (26 Eyl 2026)
      var sub = $("[data-lc-total-sub]");
      var pick = $("[data-lc-size-pick]");
      if (pick) pick.innerHTML = (state.w !== null && state.l !== null)
        ? state.w + "&quot; &times; " + state.l + "&quot;" : "";
      if (!price) return;
      var unit = parseInt(price.dataset.lcUnit, 10);
      if (!isFinite(unit)) return;                       // variant yok — sunucu ne yazdiysa kalir

      if (!ready()) {
        price.innerHTML = "&mdash;";
        if (sub) sub.textContent = (state.w === null || state.l === null)
          ? "Enter your width and drop to see the price."
          : "This width is not available with this lining.";
        return;
      }
      var panel = unit + dropEntry()[1] * extraInches(state.l) + (tbOn() ? tbPrice : 0);
      price.innerHTML = formatMoney(panel * q, moneyFormat);
      if (sub) {
        var title = sub.dataset.lcVtitle || "";
        var parts = title.split(" / ");
        parts[0] = state.w + "&quot; &times; " + state.l + "&quot;";
        var tail = " &middot; " + parts.map(function (x, i) { return i ? esc(x) : x; }).join(" / ");
        sub.innerHTML = (q === 1 ? "per panel" : q + " panels &middot; " +
          formatMoney(panel, moneyFormat) + " each") + tail;
      }
    }

    /* ---------- tamamlanan adimlar ---------- */
    function paintDone() {
      $$(".lc-item").forEach(function (it) {
        var step = it.dataset.lcStep;
        var done;
        var g = it.querySelector("[data-lc-sub-group]");
        var subOk = !g || !!state.subs[g.dataset.lcSubGroup];
        if (step === "tieback") done = !!state.tieback;
        else if (step === "header" || step === "lining") {
          done = !!it.querySelector("[data-lc-value][aria-pressed='true']") && subOk;
        }
        else if (step === "size") done = state.w !== null && state.l !== null;
        else done = !!it.querySelector("[aria-pressed='true'], [data-lc-selected]");
        it.classList.toggle("is-done", !!done);
      });
    }

    /* ---------- secili bedeni kutulara yaz ---------- */
    // Kutular musterinin yazdigini tutar; sunucunun varsayilan secimi (ilk genislik) YAZILMAZ.
    function syncSizeInputs() {
      var wEl = $("[data-lc-w]"), lEl = $("[data-lc-len]");
      if (wEl && document.activeElement !== wEl) wEl.value = state.wRaw;
      if (lEl && document.activeElement !== lEl) lEl.value = state.lRaw;
      if (wEl) { wEl.min = widths()[0] || ""; wEl.max = widths().slice(-1)[0] || ""; }
      if (lEl) { lEl.min = minDrop; lEl.max = maxDrop; }
    }

    /* ---------- rod genisligi tazelemeden sonra da kalir ----------
       Aksi halde header degisince alan bosalir, panel onerisi susar ve
       (musteri sayaca dokunmadiysa) adet eski oranin sayisinda donar. */
    function syncRodInput() {
      var r = $("[data-lc-rod]");
      if (r && state.rod && document.activeElement !== r) r.value = state.rod;
    }

    /* ---------- alt secenekler (halka rengi, astar tipi…) ----------
       Ayni anda birden fazla grup olabilir. Her grup kendi gizli property'sini
       forma yazar; grup ekranda yoksa property de gonderilmez. */
    function applySub() {
      var boxes = $$("[data-lc-sub-group]");
      var form = $(".lc-form");
      var cta = $("[data-lc-cta]");
      var active = {};

      boxes.forEach(function (box) {
        var group = box.dataset.lcSubGroup;
        active[group] = true;
        var choices = $$("[data-lc-sub]", box).map(function (b) { return b.dataset.lcSub; });

        // gecerli olmayan secim (grup degismis) temizlenir
        if (state.subs[group] && choices.indexOf(state.subs[group]) < 0) delete state.subs[group];

        $$("[data-lc-sub]", box).forEach(function (b) {
          b.setAttribute("aria-pressed", b.dataset.lcSub === state.subs[group] ? "true" : "false");
        });
        var pick = $("[data-lc-sub-pick]", box);
        if (pick) pick.textContent = state.subs[group] || "";
      });

      // ekranda olmayan gruplarin secimi dusurulur
      Object.keys(state.subs).forEach(function (g) { if (!active[g]) delete state.subs[g]; });

      // gizli input'lari senkronla
      if (form) {
        $$("[data-lc-sub-prop]", form).forEach(function (el) {
          if (!active[el.dataset.lcSubProp]) el.remove();
        });
        Object.keys(active).forEach(function (g) {
          var el = form.querySelector('[data-lc-sub-prop="' + cssEsc(g) + '"]');
          if (!state.subs[g]) { if (el) el.remove(); return; }
          if (!el) {
            el = document.createElement("input");
            el.type = "hidden";
            el.setAttribute("data-lc-sub-prop", g);
            form.appendChild(el);
          }
          el.name = "properties[" + g + "]";
          el.value = state.subs[g];
        });
      }

      // her gorunur grup icin secim zorunlu (buton karari paintCta'da)
      var missing = missingSub();
      note(missing && ready() ? "Please choose a " + missing.toLowerCase() + "." : "");
      paintCta();
    }

    function cssEsc(v) {
      return (window.CSS && CSS.escape) ? CSS.escape(v) : String(v).replace(/["\\]/g, "\\$&");
    }

    /* ---------- tieback ---------- */
    function applyTieback() {
      var prop = $("[data-lc-tieback-prop]");
      var pick = $("[data-lc-tieback-pick]");
      $$("[data-lc-tieback]").forEach(function (b) {
        b.setAttribute("aria-pressed", b.dataset.lcTieback === state.tieback ? "true" : "false");
      });
      if (prop) {
        if (state.tieback) { prop.disabled = false; prop.value = state.tieback; }
        else { prop.disabled = true; prop.value = ""; }
      }
      if (pick) pick.textContent = state.tieback || "";
    }

    /* ---------- genislik + boy (tam inc, yuvarlama YOK) ---------- */
    var sizeDebounce = null;
    function onSizeInput() {
      var wEl = $("[data-lc-w]"), lEl = $("[data-lc-len]");
      if (wEl) state.wRaw = wEl.value;
      if (lEl) state.lRaw = lEl.value;
      clearTimeout(sizeDebounce);
      sizeDebounce = setTimeout(applySize, 280);
    }

    function wholeInch(raw) {
      var t = String(raw || "").trim();
      if (!t) return { empty: true };
      var n = Number(t);
      if (!isFinite(n)) return { bad: true };
      if (Math.floor(n) !== n) return { frac: true };
      return { n: n };
    }

    function applySize() {
      var err = $("[data-lc-len-err]");
      var ws = widths();
      var W = wholeInch(state.wRaw), L = wholeInch(state.lRaw);
      var prevW = state.w;
      state.w = null; state.l = null;

      var msg = "";
      if (W.frac || L.frac) msg = "Please use whole inches.";
      else if (W.bad || L.bad) msg = "Enter a width and a drop in inches.";
      else if (!W.empty && (W.n < ws[0] || W.n > ws[ws.length - 1]))
        msg = "Width must be between " + ws[0] + " and " + ws[ws.length - 1] + " inches.";
      else if (!L.empty && (L.n < minDrop || L.n > maxDrop))
        msg = "Drop must be between " + minDrop + " and " + maxDrop + " inches.";
      showErr(err, msg);

      if (!msg && !W.empty) state.w = W.n;
      if (!msg && !L.empty && state.w !== null) state.l = L.n;
      if (!msg && !L.empty && W.empty) state.l = null;


      if (state.w !== null && state.w !== prevW) {
        var hit = sizeNodes().filter(function (n) { return parseInt(n.dataset.lcW, 10) === state.w; })[0];
        if (!hit) { state.w = null; showErr(err, "That width is not available."); }
        else {
          sizeNodes().forEach(function (n) { n.removeAttribute("data-lc-selected"); });
          hit.setAttribute("data-lc-selected", "");
          paintFullness(); paintPanelHelper(); paintQty(); paintDone();
          refetch();                                     // perde variant'i genislige bagli
          return;
        }
      }
      paintFullness(); paintPanelHelper(); paintQty(); paintDone(); paintCta();
    }

    function showErr(el, msg) {
      if (!el) return;
      el.textContent = msg || "";
      el.hidden = !msg;
    }

    /* ---------- olaylar (delegasyon — tazelemeden sonra da calisir) ---------- */
    root.addEventListener("click", function (e) {
      var t;

      if ((t = e.target.closest("[data-lc-toggle]"))) {
        var item = t.closest(".lc-item");
        var wasOpen = item.classList.contains("is-open");
        $$(".lc-item").forEach(function (i) { i.classList.remove("is-open"); });
        if (!wasOpen) item.classList.add("is-open");
        return;
      }

      if ((t = e.target.closest("[data-lc-tape-toggle]"))) {
        state.tapeTouched = true;                        // artik otomatik kapanma yok
        clearTimeout(state.tapeTimer);
        openTape(t.getAttribute("aria-expanded") !== "true");
        return;
      }

      if ((t = e.target.closest("[data-lc-qty-step]"))) {
        state.qty = state.qty + (parseInt(t.dataset.lcQtyStep, 10) || 0);
        state.qtyTouched = true;
        paintQty();
        paintPanelHelper();   // 'we set the count to N' cumlesi artik gecersiz
        return;
      }

      if ((t = e.target.closest("[data-lc-value]"))) {
        if (t.hasAttribute("data-lc-unavailable")) return;
        var pos = t.dataset.lcPos;
        $$("[data-lc-value][data-lc-pos='" + pos + "']").forEach(function (b) {
          b.setAttribute("aria-pressed", b === t ? "true" : "false");
        });
        paintFullness();
        paintPanelHelper();
        refetch();
        return;
      }

      if ((t = e.target.closest("[data-lc-sub]"))) {
        var gbox = t.closest("[data-lc-sub-group]");
        if (gbox) state.subs[gbox.dataset.lcSubGroup] = t.dataset.lcSub;
        applySub();
        paintDone();
        return;
      }

      if ((t = e.target.closest("[data-lc-tieback]"))) {
        state.tieback = t.dataset.lcTieback;
        applyTieback();
        paintQty();                                      // tieback fiyati toplamda
        paintDone();
        return;
      }

      if ((t = e.target.closest("[data-lc-thumb]"))) {
        state.photo = parseInt(t.dataset.lcThumb, 10) || 0;
        paintGallery();
        return;
      }
    });

    root.addEventListener("input", function (e) {
      if (e.target.matches("[data-lc-len]") || e.target.matches("[data-lc-w]")) onSizeInput();
      if (e.target.matches("[data-lc-rod]")) { state.rod = e.target.value; paintPanelHelper(); }
      if (e.target.matches("[data-lc-qty]")) {
        state.qtyTouched = true;
        var n = parseInt(e.target.value, 10);
        if (isFinite(n) && n >= 1) { state.qty = n; paintQty(); paintPanelHelper(); }
      }
    });

    // alan bosaltilip biraklirsa gecerli adede geri don
    root.addEventListener("change", function (e) {
      if (e.target.matches("[data-lc-qty]")) paintQty();
    });

    /* ---------- sepete ekle: perde + extra drop, tek istekte ---------- */
    root.addEventListener("submit", function (e) {
      var form = e.target.closest(".lc-form");
      if (!form) return;
      e.preventDefault();
      if (!ready() || state.busy) { paintCta(); return; }
      var miss = missingSub();
      if (miss) { note("Please choose a " + miss.toLowerCase() + "."); return; }
      if (tbOn() && !tbVariant) { note("Matching tieback is not available right now."); return; }

      var vid = parseInt(($("[data-lc-variant-id]") || {}).value, 10);
      var d = dropEntry();
      var extra = extraInches(state.l);
      var q = state.qty;
      var ref = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);

      var props = {};
      $$("input[name^='properties[']", form).forEach(function (el) {
        if (el.disabled || !el.value) return;
        props[el.name.slice(11, -1)] = el.value;
      });
      props["Drop"] = state.l + " in";                 // genislik variant'ta zaten yazili
      props["_lc_ref"] = ref;
      props["_lc_drop"] = String(extra);                 // panel basina extra inc
      if (tbOn()) props["_lc_tb"] = "1";                 // panel basina 1 tieback

      var items = [{ id: vid, quantity: q, properties: props }];
      if (extra > 0) items.push({ id: d[0], quantity: q * extra, properties: {
        "_lc_ref": ref, "For": productTitle + " \u2014 " + state.w + "\" \u00d7 " + state.l + "\""
      } });
      if (tbOn()) items.push({ id: tbVariant, quantity: q, properties: {
        "_lc_ref": ref, "_lc_addon": "tieback",
        "For": productTitle + " \u2014 " + state.w + "\" \u00d7 " + state.l + "\""
      } });

      var cta = $("[data-lc-cta]");
      if (cta) cta.disabled = true;
      note("");
      var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
      fetch(rootUrl + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw j; return j; });
      }).then(function () {
        window.location.href = rootUrl + "cart";
      }).catch(function (j) {
        note((j && (j.description || j.message)) || "Could not add to cart. Please try again.");
        paintCta();
        if (window.console) console.error("[lumiso-configurator] cart/add", j);
      });
    });

    paintGallery();
    restore(null);
  }

  function init() {
    document.querySelectorAll("[data-lc]").forEach(boot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else { init(); }

  // tema editoru
  document.addEventListener("shopify:section:load", init);
})();
